(function () {
    window.addEventListener('load', function () {
        initCustomSelect();
    });


    // USE INCLUDE_BLANK OPTION IN CF7 FOR EVERY SELECT.
    // ALSO USE CLASS first-option-placeholder IF YOU WANT TO HAVE PLACEHOLDER TEXT INSTEAD OF NORMAL LABEL
    // IF YOU USE THAT PLACEHOLDER PLEASE MAKE SURE, THAT THE FIRST OPTION WILL BE A NON CLICKABLE PLACEHOLDER

    function initCustomSelect() {
        let elems = document.querySelectorAll('.customSelect');

        if (elems) {
            for (let i = 0, count = elems.length; i < count; i += 1) {
                let container = elems[i],
                    select = container.querySelector('select'),
                    options = select.querySelectorAll('option');

                let customList_input = document.createElement('div');
                customList_input.classList.add('customList-input');

                let customList = document.createElement('div');
                customList.classList.add('customList-wrapper');

                for (let j = 0, count = options.length; j < count; j += 1) {
                    if (select.classList.contains('first-option-placeholder') && j == 0) {
                        customList_input.textContent = options[j].value;
                    } else {
                        if (j == 0) {
                            customList_input.textContent = options[j].innerHTML;
                        }
                        let option = document.createElement('div');
                        option.classList.add('customList-option');

                        if (select.classList.contains('show-content')) {
                            option.textContent = options[j].innerHTML;
                        } else {
                            option.textContent = options[j].value;
                        }
                        option.setAttribute('data-index', j);

                        option.addEventListener('click', function () {
                            let index = this.getAttribute('data-index'),
                                value = this.innerHTML;

                            select.selectedIndex = index;
                            select.dispatchEvent(new Event('change'));
                            customList_input.innerHTML = value;
                            customList_input.classList.remove('active');
                        });

                        customList.appendChild(option);
                    }

                }

                container.prepend(customList);
                container.prepend(customList_input);

                customList_input.addEventListener('click', function () {

                    if (!this.classList.contains('active')) {
                        let activeSelect = document.querySelector('.customList-input.active');

                        if (activeSelect) {
                            activeSelect.classList.toggle('active');
                        }
                    }
                    this.classList.toggle('active');
                });
            }
        }
    }

})()


//////////////////
// WEBPACK FOOTER
// ./js/components/custom-form.js
// module id = 4
// module chunks = 0